import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AppRoutes from "./App/AppRoutes";
import DevRoutes from "./Dev/DevRoutes";
import AppLinksRoutes from "./AppLinks/AppLinksRoutes";
import LaunchPadRoutes from "./LaunchPad/LaunchPadRoutes";
import ProgramRoutes from "./Programs/ProgramRoutes";

const MainRoutes: React.FC = () => {
  return (
    <div className="h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/programs" />} />
          <Route path="/launchpad/*" element={<LaunchPadRoutes />} />
          <Route path="/app/*" element={<AppRoutes />} />
          <Route path="/dev/*" element={<DevRoutes />} />
          <Route path="/app-links/*" element={<AppLinksRoutes />} />
          <Route path="/programs/*" element={<ProgramRoutes />} />
          <Route path="*" element={<Navigate to="/launchpad/login" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default MainRoutes;
